<app-form-group *ngIf="localGroup" [formGroup]="localGroup">
    <label class="skv-form-label">
        <ng-content></ng-content>
    </label>
    <input [ngClass]="classes" formControlName="control" [type]="type" />
    <span *ngIf="error" class="text-error text-small">{{error}}</span>
</app-form-group>